import React from 'react'
import {
  Box,
  Breadcrumbs,
  Link,
  Typography,
  Hidden,
  Button,
} from '@material-ui/core'
import { Link as RouterLink } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import ArrowBackIcon from 'components/material-symbol/icons/ArrowBack'
import ChevronRightIcon from 'components/material-symbol/icons/ChevronRight'
import PageHeaderTabsSection from 'components/page-header/page-header-tabs-section'
import { pageHeaderBackButton } from 'components/page-header/page-header-layout'
import { pageTitleCapitalization } from 'lib/typography/capitalization-styles'

const useStyles = makeStyles(theme => ({
  headerContainer: {
    display: 'flex',
    borderTopColor: theme.palette.grey[300],
    borderTopStyle: 'solid',
    borderTopWidth: '1px',

    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(5),

    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(2),
    },
  },

  titleContainer: {
    display: 'flex',
    minWidth: 'max-content',
    flexGrow: '1',
    flexDirection: 'column',
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
    },
  },
  title: {
    fontWeight: '500',
    fontSize: '30px',
    lineHeight: '42px',
    ...pageTitleCapitalization,
    [theme.breakpoints.down('xs')]: {
      fontSize: '16px',
    },
  },
  crumbTitle: {
    ...pageTitleCapitalization,
  },
  crumbSeparator: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    color: theme.palette.text.secondary,
  },
  backButtonContainer: {
    [theme.breakpoints.up('sm')]: {
      width:
        // 67 from the button + 16 from the padding
        'calc(67px + 16px)',
    },
  },
  backButtonRoot: {
    ...pageHeaderBackButton(theme),
  },
  backButtonIcon: {
    fontSize: 24,
  },
  backButtonPlaceholder: {
    width: 40,
    height: 40,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  actionWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
    },
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
    },
  },
}))

function PageCrumbs({ title, crumbs }) {
  const classes = useStyles()
  if (!crumbs) {
    return null
  }

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator={<ChevronRightIcon className={classes.crumbSeparator} />}
    >
      {crumbs.map((value, index) => {
        if (index === crumbs.length - 1) {
          return (
            <Typography
              color="textPrimary"
              className={classes.crumbTitle}
              key={`${index}+${value}`}
            >
              {title}
            </Typography>
          )
        } else {
          return (
            <Link
              component={RouterLink}
              color="inherit"
              key={`${index}+${value}`}
              to={value.to}
            >
              {value.label}
            </Link>
          )
        }
      })}
    </Breadcrumbs>
  )
}

export default function PageHeader({
  title,
  crumbs,
  actions,
  tabs,
  isMobile,
  activeTab,
  ...props
}) {
  const classes = useStyles()
  return (
    <>
      <Box data-testid="student-header" {...props}>
        <Box className={classes.headerContainer}>
          {crumbs && crumbs.length > 0 ? (
            <Box className={classes.backButtonContainer}>
              <Button
                component={RouterLink}
                to={
                  activeTab && isMobile
                    ? crumbs[crumbs.length - 1].to
                    : crumbs[0].to
                }
                className={classes.backButtonRoot}
              >
                <ArrowBackIcon className={classes.backButtonIcon} />
              </Button>
            </Box>
          ) : null}
          <Box className={classes.titleContainer}>
            <Hidden xsDown>
              <PageCrumbs {...{ crumbs, title }} />
            </Hidden>
            {isMobile ? (
              <Typography
                variant="h2"
                color="textPrimary"
                className={classes.title}
                data-testid="page-header-title"
              >
                {activeTab ? `${title} ${activeTab}` : title}
              </Typography>
            ) : (
              <Typography
                variant="h2"
                color="textPrimary"
                className={classes.title}
                data-testid="page-header-title"
              >
                {title}
              </Typography>
            )}
          </Box>
          <Hidden xsDown>
            <Box className={classes.actionWrapper}>{actions}</Box>
          </Hidden>
        </Box>
        <Hidden xsDown>
          {tabs ? (
            <PageHeaderTabsSection
              reserveBackButtonColumn={Boolean(crumbs && crumbs.length > 0)}
              backButtonContainerClassName={classes.backButtonContainer}
              hasCrumbs={Boolean(crumbs && crumbs.length > 0)}
              useStudentTitleOffset
            >
              {tabs}
            </PageHeaderTabsSection>
          ) : null}
        </Hidden>
      </Box>
    </>
  )
}
